export default __webpack_public_path__ + "static/media/ZETONY_U_ANIMATORA.a9cb2957.png";